import React from "react";

const NonAuthLayout = (props) => {
  return <div>{props?.children}</div>;
};

export default NonAuthLayout;
